import { render, staticRenderFns } from "./WorkshopsOncommence.vue?vue&type=template&id=521e6630&"
import script from "./WorkshopsOncommence.vue?vue&type=script&lang=js&"
export * from "./WorkshopsOncommence.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopsOncommence.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VMain,VRow})
